import * as d3 from 'd3';

const getRanking = new Promise((resolve, reject) => {
  d3.json('data/modelo_funes_ranking.json')
    .then(resolve)
    .catch(reject);
});

const getTipoProcesoOsce = new Promise((resolve, reject) => {
  d3.json('data/ranking_por_tipo_proceso_osce.json')
    .then(resolve)
    .catch(reject);
});

const getTiposTotales = new Promise((resolve, reject) => {
  d3.json('data/modelo_funes_tipos_totales.json')
    .then(resolve)
    .catch(reject);
});

const getEmpresasExoneracionesDirectas = new Promise((resolve, reject) => {
  d3.json('data/ranking_empresas_exoneraciones_directas.json')
    .then(resolve)
    .catch(reject);
});

const getData = () => (
  Promise.all([
    getRanking,
    getTipoProcesoOsce,
    getTiposTotales,
    getEmpresasExoneracionesDirectas,
  ])
);

export default getData;
